import { useCallback, useRef, useState } from "react"
import { useLocalization } from "@tm/localization"
import { ECounterType } from "@tm/models"
import { Icon, Button, MenuItem, Menu, Tooltip, ListItemIcon, ListItemText } from "@tm/components"
import { TmaHelper } from "@tm/utils"
import { Link } from "react-router-dom"
import { useOwnListsCompilationsParameters } from "@tm/context-distribution"

type Props = {
    repairTimesUrl: string | undefined
    onCreateCustomRepairTime(): void
    onOpenOwnRepairTimes(): void
}

export default function AddWork({ repairTimesUrl, onCreateCustomRepairTime, onOpenOwnRepairTimes }: Props) {
    const { translateText } = useLocalization()
    const { hasMyWorks } = useOwnListsCompilationsParameters()

    const buttonRef = useRef<HTMLButtonElement>(null)

    const [openMenu, setOpenMenu] = useState<boolean>(false)

    const handleOpenMenu = useCallback(
        (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            e?.stopPropagation?.()
            TmaHelper.GeneralCountEvent.Call(ECounterType.CostEstimateAddLabourTime)
            setOpenMenu(!openMenu)
        },
        [openMenu]
    )

    const handleCreateClick = useCallback((e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        e?.stopPropagation?.()
        onCreateCustomRepairTime()
        setOpenMenu(false)
    }, [])

    const handleOpenOwnRepairTimesClick = useCallback((e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        e?.stopPropagation?.()
        onOpenOwnRepairTimes()
        setOpenMenu(false)
    }, [])

    return (
        <>
            <Button onClick={handleOpenMenu} ref={buttonRef} startIcon={<Icon name="plus" />} color="highlight" variant="contained" />
            <Menu
                open={openMenu}
                onClose={() => setOpenMenu(false)}
                anchorEl={buttonRef.current}
                anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
            >
                <MenuItem onClick={handleCreateClick}>
                    <ListItemIcon>
                        <Icon name="add" />
                    </ListItemIcon>
                    <ListItemText>
                        {translateText(13907)}
                        <Tooltip title={translateText(13909)}>
                            <Icon name="info" />
                        </Tooltip>
                    </ListItemText>
                </MenuItem>
                {hasMyWorks && (
                    <MenuItem onClick={handleOpenOwnRepairTimesClick}>
                        <ListItemIcon>
                            <Icon name="individual-repairtimes" />
                        </ListItemIcon>
                        <ListItemText>{translateText(920)}</ListItemText>
                    </MenuItem>
                )}
                {repairTimesUrl && (
                    <MenuItem<Link> component={Link} to={repairTimesUrl} disabled={!repairTimesUrl}>
                        <ListItemIcon>
                            <Icon name="repairtimes" />
                        </ListItemIcon>
                        <ListItemText>{translateText(83)}</ListItemText>
                    </MenuItem>
                )}
            </Menu>
        </>
    )
}
